module.exports = __webpack_public_path__ + "static/media/protein-bottom.66b27655.png";